<template>
  <div id="app">
    <formulaire />
  </div>
</template>

<script>
// @ is an alias to /src
import Formulaire from '@/views/Formulaire.vue'
export default {
  components: {
    Formulaire
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}

label input {
  position: absolute;
  left: -9999px;
}

label input:checked + h4, label input:checked + span, label input:checked + strong {
  background-color: #def8ff;
}

label input:disabled + h4, label input:disabled + span, label input:disabled + strong {
  color: #ccc;
}

label input:checked + h4:before, label input:checked + span:before, label input:checked + strong:before {
  box-shadow: inset 0 0 0 0.4375em #469eb5;
}

label h4, label span, label strong {
  display: flex;
  align-items: center;
  padding: 0.375em 0.75em 0.375em 0.375em;
  border-radius: 99em;
  transition: 0.25s ease;
}

label h4:hover, label span:hover, label strong:hover {
  background-color: #def8ff;
}

label h4:before, label span:before, label strong:before {
  display: flex;
  flex-shrink: 0;
  content: "";
  background-color: #fff;
  width: 1.5em;
  height: 1.5em;
  border-radius: 50%;
  margin-right: 0.375em;
  transition: 0.25s ease;
  box-shadow: inset 0 0 0 0.125em #469eb5;
}

label input:disabled + h4:before, label input:disabled + span:before, label input:disabled + strong:before {
  box-shadow: inset 0 0 0 0.125em #ccc;
}
</style>